import { Dictionary } from '../../../../../shared/models/dictionary';
import { ServiceProjectStatusEnum } from '../enums/status.enum';

export const getServiceProjectStatus = () => [
  { id: ServiceProjectStatusEnum.NEW, name: 'Nowe' },
  { id: ServiceProjectStatusEnum.ACCEPTED, name: 'Do naprawy' },
  { id: ServiceProjectStatusEnum.REJECTED, name: 'Odrzucone' },
  { id: ServiceProjectStatusEnum.DONE, name: 'Naprawione' },
] as Dictionary[];
